import { fitSelect2DropdownToViewport } from './floating-dropdown-position.js';

export function select2MediumOptions(overrides) {
    return Object.assign({
        theme: 'bootstrap-5',
        containerCssClass: 'select2--medium',
        selectionCssClass: 'select2--medium',
        dropdownCssClass: 'select2--medium',
        width: '100%',
    }, overrides || {});
}

export function isSelect2Initialized($select) {
    return Boolean($select && $select.length && $select.hasClass('select2-hidden-accessible'));
}

export function focusOpenSelect2Search(select) {
    const $select = select && select.jquery ? select : $(select);
    const inst = $select && $select.length ? $select.data('select2') : null;
    const $dropdown = inst && (inst.$dropdown || (inst.dropdown ? $(inst.dropdown) : null));
    const fromDropdown = $dropdown && $dropdown.length
        ? $dropdown.find('.select2-search__field').get(0)
        : null;
    const field = fromDropdown
        || document.querySelector('.select2-dropdown .select2-search__field')
        || document.querySelector('.select2-container--open .select2-search__field');
    if (field) {
        field.focus();
    }
}

export function bindSelect2OpenSearchFocus($select) {
    const $el = $select && $select.jquery ? $select : $($select);
    if (!$el || !$el.length) {
        return;
    }
    $el.off('select2:open.select2SearchFocus').on('select2:open.select2SearchFocus', function () {
        const select = this;
        setTimeout(function () {
            focusOpenSelect2Search(select);
        }, 0);
    });
}

function bindSelect2ViewportFit($select) {
    $select
        .off('select2:open.select2ViewportFit')
        .on('select2:open.select2ViewportFit', function () {
            const selectEl = this;
            requestAnimationFrame(function () {
                fitSelect2DropdownToViewport(selectEl);
                requestAnimationFrame(function () {
                    fitSelect2DropdownToViewport(selectEl);
                });
            });
        });
}

export function ensureSelect2($select, options) {
    if (!$select || !$select.length) {
        throw new Error('ensureSelect2: select is required');
    }
    if (typeof $select.select2 !== 'function') {
        throw new Error('ensureSelect2: select2 is required');
    }
    if (isSelect2Initialized($select)) {
        bindSelect2ViewportFit($select);
        return;
    }
    $select.select2(select2MediumOptions(options));
    bindSelect2ViewportFit($select);
}

export function destroySelect2($select) {
    if (!$select || !$select.length || !isSelect2Initialized($select)) {
        return;
    }
    if (typeof $select.select2 !== 'function') {
        throw new Error('destroySelect2: select2 is required');
    }
    $select.off('select2:open.select2ViewportFit');
    $select.select2('destroy');
}
